import { InferOutput } from 'valibot'
import { OptionalNullableSgColumnIDSchema, SgColumnIDSchema } from './SgColumnID.type'

export const ProfileIdSchema = SgColumnIDSchema
export const OptionalNullableProfileIDSchema = OptionalNullableSgColumnIDSchema

export type ProfileId = InferOutput<typeof ProfileIdSchema>
